export default "__VITE_ASSET__DzY73e2c__"